"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrightnessCorrectionWriter = void 0;
var gamma_brightnessCorrection_1 = require("../brightnessCorrection/gamma.brightnessCorrection");
function writeGammaBrightnessCorrection(brightnessCorrection) {
    var state = brightnessCorrection.state;
    var exponent = state.exponent;
    return {
        id: state.id,
        tag: 'gamma',
        exponent: exponent
    };
}
var BrightnessCorrectionWriter = /** @class */ (function () {
    function BrightnessCorrectionWriter() {
    }
    BrightnessCorrectionWriter.write = function (brightnessCorrection) {
        if (gamma_brightnessCorrection_1.CollectionModelGammaBrightnessCorrection.isGamma(brightnessCorrection)) {
            return writeGammaBrightnessCorrection(brightnessCorrection);
        }
        throw new Error("Unexpected drawable: ".concat(brightnessCorrection.id, ":").concat(brightnessCorrection.state.tag));
    };
    return BrightnessCorrectionWriter;
}());
exports.BrightnessCorrectionWriter = BrightnessCorrectionWriter;
//# sourceMappingURL=collection.model.write.brightnessCorrection.js.map